<template>
  <div :class="{ 'has-error': validationMessage }">
    <div class="input-group-prepend">
      <div class="input-group-text">
        <i :class="field.icon"></i>
      </div>
    </div>

    <input
      :type="field.type"
      v-model="field.data"
      @input="validate"
      class="form-control"
      :id="field.id"
      :name="field.id"
      :placeholder="field.placeholder"
      :autocomplete="field.autocomplete"
    />
    <div class="text-left text-danger feedback-message" v-if="validationMessage">
      <small>{{ validationMessage }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'validation-field',
  props: {
    field: Object,
    submitted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      validationMessage: ''
    };
  },
  watch: {
    submitted(newVal, oldVal) {
      if (newVal) {
        this.$set(this.field, 'data', '');
        this.$forceUpdate();
      }
    }
  },
  methods: {
    validate() {
      if (!this.field.required && !this.field.data) {
        this.validationMessage = '';
        return true;
      }

      if (!this.field.data) {
        this.validationMessage = `Field ${this.field.id} is required`;
        return false;
      }

      if (!RegExp(this.field.regex).test(this.field.data)) {
        this.validationMessage = `Invalid ${this.field.id}`;
        return false;
      }
      this.validationMessage = '';
      return true;
    }
  }
};
</script>
